/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{VertexArrayObject as e}from"../../../webgl/VertexArrayObject.js";class r extends e{}export{r as VertexArrayObject};
